import { useContext, useEffect, useState, useCallback } from "react";
import { Context as CompaniesContext } from "../context/CompaniesContext";

export default id => {
  const {
    state: { selectedCompany: companyDetail },
    getCompanybyID,
    resetValues
  } = useContext(CompaniesContext);

  const [loadingCompanyDetail, setLoadingCompanyDetail] = useState(true);

  const fetchData = useCallback(async () => {
    setLoadingCompanyDetail(true);
    await getCompanybyID(id);
    setLoadingCompanyDetail(false);
  }, [id, getCompanybyID]);
  const reset = useCallback(resetValues, []);

  useEffect(() => {
    return () => reset();
  }, [reset]);

  useEffect(() => {
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [{ companyDetail, loadingCompanyDetail, fetchData }];
};
